
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatDate, formatBool } from "@/utils";
import { ReceiveStockOrderRequest, ReceiveItem } from "@/models/api/barcodeSystem/stockOrders/receive";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";


const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class StockOrderReceiving extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  receiveStockOrderRequest: ReceiveStockOrderRequest;

  @Prop({default: null})
  validationMessages: string[];

  get receiveItems(): Array<ReceiveItem> {
    return this.receiveStockOrderRequest ? this.receiveStockOrderRequest.stockOrderItems : [];
  }

  get statusOptions() : Array<any> {
    return this.receiveStockOrderRequest && this.receiveStockOrderRequest.stockOrderItemStatuses ? 
      this.receiveStockOrderRequest.stockOrderItemStatuses.map(x => ({ label: x.description, value: x.code })) :
      [];
  }

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }


  get crn(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.crn
      : ""; 
  }

  get companyName(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.displayBillToCompanyId
      : "";  
  }

  set displayBillToCompanyId(val: string){
  }

  get shippingFacility(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.shippingFacility
      : ""; 
  }

  set shippingFacility(val: string){
  }  

  get status(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.status
      : "";  
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.statusDescription
      : "";  
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get shipDateFormatted(): string {
    return this.receiveStockOrderRequest
      ? formatDate(this.receiveStockOrderRequest.shipDate)
      : "";
  }

  set shipDateFormatted(val: string){
  }

  get anticipatedReceiveDateFormatted(): string{
    return this.receiveStockOrderRequest
      ? formatDate(this.receiveStockOrderRequest.anticipatedReceiveDate)
      : "";
  }

  set anticipatedReceiveDateFormatted(val: string){
  }

  get stockOrderItemCount() : number
  {
    return this.receiveStockOrderRequest && this.receiveStockOrderRequest.stockOrderItems
      ? this.receiveStockOrderRequest.stockOrderItems.length
      : 0;
  }

  itemIsShort(item) : boolean
  {
    return item.status == 'M';
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val) {
    return formatDateWithTime(val)
  }

  formatBool(val) {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  handleDamagedChanged(data) {
    if(data.damaged)
    {
      data.quantityDamaged = data.quantity;
    }
    else
    {
      data.quantityDamaged = 0;
      data.damageCode = null;
    }
  }

  handleStatusChanged(data) {
    if(this.itemIsShort(data))
    {
      data.quantityReceived = 0;
    }
    else
    {
      data.quantityReceived = data.quantity;
    }
  }

}
